import { Modal, Table } from 'antd';
import styled from 'styled-components';
import {
  CompanyMobileActionButton,
  CompanyMobileDataTable,
  CompanyMobileDetailLabel,
  CompanyMobileDetailRow,
  CompanyMobileDetailRows,
  CompanyMobileDetailSection,
  CompanyMobileDetailSectionHeader,
  CompanyMobileDetailValue,
  CompanyMobileField,
  CompanyMobileFilterActions,
  CompanyMobileFilterApplyButton,
  CompanyMobileFilterButton,
  CompanyMobileFilterDrawer,
  CompanyMobileFilterField,
  CompanyMobileFilterFields,
  CompanyMobileFilterForm,
  CompanyMobileFilterRow,
  CompanyMobileFilterSelect,
  CompanyMobileForm,
  CompanyMobileHeaderActions,
  CompanyMobileIconButton,
  CompanyMobilePage,
  CompanyMobilePageButton,
  CompanyMobilePagination,
  CompanyMobilePaginationActions,
  CompanyMobilePaginationInfo,
  CompanyMobileSearch,
  CompanyMobileSecondaryButton,
  CompanyMobileSection,
  CompanyMobileSectionHeader,
  MobileCompanyHeader,
} from '../company/mobile';

export const AdminMobilePage = CompanyMobilePage;
export const AdminMobileHeader = MobileCompanyHeader;
export const AdminMobileHeaderActions = CompanyMobileHeaderActions;
export const AdminMobileActionButton = CompanyMobileActionButton;
export const AdminMobileSecondaryButton = CompanyMobileSecondaryButton;
export const AdminMobileIconButton = CompanyMobileIconButton;
export const AdminMobileFilterRow = CompanyMobileFilterRow;
export const AdminMobileSearch = CompanyMobileSearch;
export const AdminMobileFilterButton = CompanyMobileFilterButton;
export const AdminMobileTableCard = styled.div`
  width: 100%;
  overflow-x: auto;
  overflow-y: hidden;
  background: #ffffff;

  .ant-table-wrapper,
  .ant-spin-nested-loading,
  .ant-spin-container,
  .ant-table,
  .ant-table-container,
  .ant-table-content,
  table {
    width: 824px !important;
    min-width: 824px !important;
  }

  .ant-table-content table {
    min-width: 824px;
  }

  .ant-table {
    font-size: 12px;
  }

  .ant-table-thead > tr,
  .ant-table-tbody > tr {
    box-shadow: inset 0 -1px 0 #e8ecf3;
  }

  .ant-table-thead > tr > th {
    height: 46px;
    padding: 12px;
    box-sizing: border-box;
    border-right: 1px solid #d9d9d9;
    border-bottom: 0;
    background: #fafafa;
    color: #1e1e1e;
    font-size: 14px;
    font-weight: 600;
    line-height: 1.2;
    white-space: nowrap;
  }

  .ant-table-thead > tr > th:last-child {
    border-right: 0;
  }

  .ant-table-tbody > tr > td {
    height: 48px;
    padding: 16px 12px;
    box-sizing: border-box;
    border-bottom: 0;
    color: #1e1e1e;
    font-size: 12px;
    line-height: 1.2;
    white-space: nowrap;
  }

  .ant-tag {
    margin-inline-end: 0;
    border-radius: 5px;
    font-size: 14px;
    font-weight: 600;
    line-height: 22px;
  }

  .mobile-link-button {
    max-width: 100%;
    padding: 0;
    border: 0;
    background: transparent;
    color: #0e3b7a;
    font: inherit;
    line-height: 1.2;
    text-align: left;
    cursor: pointer;
  }
`;
export const AdminMobileDataTable = CompanyMobileDataTable;
export const AdminMobilePagination = CompanyMobilePagination;
export const AdminMobilePaginationInfo = CompanyMobilePaginationInfo;
export const AdminMobilePaginationActions = CompanyMobilePaginationActions;
export const AdminMobilePageButton = CompanyMobilePageButton;
export const AdminMobileFilterDrawer = CompanyMobileFilterDrawer;
export const AdminMobileFilterForm = CompanyMobileFilterForm;
export const AdminMobileFilterFields = CompanyMobileFilterFields;
export const AdminMobileFilterField = CompanyMobileFilterField;
export const AdminMobileFilterSelect = CompanyMobileFilterSelect;
export const AdminMobileFilterActions = CompanyMobileFilterActions;
export const AdminMobileFilterApplyButton = CompanyMobileFilterApplyButton;
export const AdminMobileForm = CompanyMobileForm;
export const AdminMobileSection = CompanyMobileSection;
export const AdminMobileSectionHeader = CompanyMobileSectionHeader;
export const AdminMobileField = CompanyMobileField;
export const AdminMobileDetailSection = CompanyMobileDetailSection;
export const AdminMobileDetailSectionHeader = CompanyMobileDetailSectionHeader;
export const AdminMobileDetailRows = CompanyMobileDetailRows;
export const AdminMobileDetailRow = CompanyMobileDetailRow;
export const AdminMobileDetailLabel = CompanyMobileDetailLabel;
export const AdminMobileDetailValue = CompanyMobileDetailValue;

export const AdminMobileDetailHeaderBar = styled.div`
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 12px;
  width: 100%;
  margin-bottom: 12px;

  ${AdminMobileDetailSectionHeader} {
    flex: 1 1 auto;
    min-width: 0;
    margin-bottom: 0;
  }

  ${AdminMobileSecondaryButton} {
    flex: 0 0 auto;
    min-width: 102px;
    padding-inline: 12px;
  }
`;

export const AdminMobilePasswordRow = styled.div`
  display: grid;
  grid-template-columns: minmax(0, 1fr) 96px;
  gap: 12px;
  align-items: end;
  width: 100%;
  margin-bottom: 8px;

  ${AdminMobileField} {
    margin-bottom: 0;
  }

  .ant-input-affix-wrapper {
    display: flex;
    align-items: center;
    height: 44px;
    min-height: 44px;
    padding: 0 10px;
    border-color: #e8ecf3 !important;
    border-radius: 6px !important;
    box-shadow: none !important;
  }

  .ant-input-affix-wrapper > input.ant-input {
    height: 42px;
    min-height: 42px;
    padding: 0;
    border: 0;
    font-size: 12px;
    line-height: 42px;
  }

  .ant-input-password-icon {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    color: #1e1e1e;
  }

  .ant-btn {
    width: 96px;
    height: 44px;
    border: 0;
    border-radius: 6px;
    background: #d9d9d9;
    color: #000000;
    font-size: 12px;
    font-weight: 400;
  }
`;

export const AdminMobileCheckbox = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  margin-top: 2px;
  color: #000000;
  font-size: 12px;
  line-height: 1.2;
`;

export const AdminMobileCompanyHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  width: 100%;
  margin-bottom: 8px;
`;

export const AdminMobileCompanyCopy = styled.div`
  min-width: 0;

  h2 {
    margin: 0;
    color: #1e1e1e;
    font-size: 14px;
    font-weight: 600;
    line-height: 1.2;
  }

  p {
    margin: 4px 0 0;
    color: #768499;
    font-size: 12px;
    line-height: 1.2;
  }
`;

export const AdminMobileCompanyTable = styled(Table)`
  width: 100%;

  .ant-table-container {
    overflow: hidden;
    border-radius: 12px 12px 0 0;
  }

  .ant-table-content table {
    min-width: 760px;
  }

  && .ant-table-thead > tr > th {
    height: 46px;
    padding: 12px;
    border-right: 1px solid #d9d9d9;
    border-bottom: 1px solid #d9d9d9;
    background: #fafafa;
    color: #1e1e1e;
    font-size: 12px;
    font-weight: 600;
    line-height: 1.2;
    white-space: nowrap;
  }

  && .ant-table-tbody > tr > td {
    height: 48px;
    padding: 16px 12px;
    border-bottom: 1px solid #e8ecf3;
    color: #1e1e1e;
    font-size: 12px;
    line-height: 1.2;
    white-space: nowrap;
  }
`;

export const AdminMobileChooseCompanyModal = styled(Modal)`
  .ant-modal-content {
    padding: 16px 12px 0;
    border-radius: 8px;
  }

  .ant-modal-header {
    margin-bottom: 12px;
    text-align: center;
  }

  .ant-modal-title {
    color: #1e1e1e;
    font-size: 16px;
    font-weight: 600;
    line-height: 1.2;
  }

  .ant-modal-close {
    top: 16px;
    right: 12px;
  }

  .ant-modal-body {
    padding: 0;
  }

  .ant-modal-footer {
    margin: 12px -12px 0;
    padding: 12px;
    border-top: 1px solid #e8ecf3;
  }

  .ant-modal-footer .ant-btn {
    min-width: 94px;
    height: 44px;
    border-radius: 6px;
    font-size: 16px;
    font-weight: 600;
  }

  .ant-modal-footer .ant-btn-primary {
    background: #264284;
  }
`;

export const AdminMobileModalFilters = styled.div`
  display: grid;
  grid-template-columns: minmax(0, 1fr);
  gap: 8px;
  margin-bottom: 12px;
`;

export const AdminMobileModalSearch = styled(AdminMobileSearch)`
  &&,
  &&.ant-input-affix-wrapper {
    width: 100%;
  }
`;
